import React from 'react';
import classnames from 'classnames';
import i18n from 'i18next';

import { Typo } from 'uikit/content';

import getIsCurrentTimeBetween from '../helpers/getIsCurrentTimeBetween';
import styles from '../styles/videoLiveAndUpcomingCardIndicator.module.scss';

export default function VideoLiveAndUpcomingCardIndicator({ className, startAt, endAt }) {
  const liveNow = (
    <div className={classnames(styles.item, className)}>
      <span className={styles.item_live_now_icon} />
      <Typo color="inherit" element="span" variant="s01">
        {i18n.t('live-now')}
      </Typo>
    </div>
  );

  const upcoming = (
    <div className={classnames(styles.item, className)}>
      <Typo color="inherit" element="span" variant="s01">
        {i18n.t('upcoming')}
      </Typo>
    </div>
  );

  const isEnded = Date.now() > new Date(endAt).getTime();

  if (isEnded) return <div />;

  const isLive = getIsCurrentTimeBetween({
    startTime: startAt,
    endTime: endAt,
  });

  return isLive ? liveNow : upcoming;
}
